import { useSelector } from 'react-redux';
import { getTenantIds } from '../stores/slices/preferences';
import { useActiveSubtenants } from './useActiveSubtenants';

export function useTenantIds(): string[] | undefined {
  const preference = useSelector(getTenantIds());
  const activeNames = useActiveSubtenants()?.map(({ name }) => name);
  if (!activeNames) {
    return undefined;
  }
  return preference ? preference.filter((name) => activeNames.includes(name)) : activeNames;
}
